import logo from '../../static/svg-1.svg'
import tks from '../../static/svg-2.svg'
import tks2 from '../../static/progress.svg'
import tks3 from '../../static/Server-amico.svg'
import dp from '../../static/dp.jpg'
export const homeObjOne = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Product Design and Development',
    headline: 'I Am Here To Help You',
    description:
      'I can solve your problems more efficiently and effectively with greater UI and UX experience for your users.',
    buttonLabel: 'Get Started',
    imgStart: '',
    img: logo,
    alt: 'header-img',
    start: ''
  };
  
  export const homeObjTwo = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Professional Design',
    headline: 'Extremely easy and professional design process',
    description:
      "Once you've joined, I will reach out to you and get your requirements and analyzing them, I will show you the best optimized way to do things.",
    buttonLabel: 'Learn More',
    imgStart: '',
    img: tks,
    alt: 'head-2',
    start: ''
  };
  
  export const homeObjThree = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Rohaan Joshi',
    headline:
      'Now the process of working is very simple!',
    description:
      "I like to make things simple and easy to understand and adopt, without taking much extra efforts.",
    buttonLabel: 'View Case Study',
    imgStart: 'start',
    img: tks2,
    alt: 'Vault',
    start: 'true'
  };
  
  export const homeObjFour = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Secure Database',
    headline: 'All your data will be stored on secure cloud server',
    description:
      'You will never have to worry about your information getting leaked. All your data stored on trusted cloud like GCP, Azure, IBM Cloud and in trusted countries like India, Japan, Germany, Austrila, USA etc.',
    buttonLabel: "Get Started",
    imgStart: 'start',
    img: tks3,
    alt: 'Vault',
    start: 'true'
  };

  export const aboutme = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Rohaan Joshi',
    headline:
      '"Every Thing Is Very Simple!!!"',
    description:
      "Hello Everyone, Rohaan Here. I am Smart working person who loves to Make things simple and faster. I like to develop Secured and Effient things. Which can be used by anyone.",
    buttonLabel: 'Know More',
    imgStart: 'start',
    img: dp,
    alt: 'Vault',
    start: 'true'
  }